import React from "react";
import ReactDOM from "react-dom/client";
const App = React.lazy(() => import("./App").then(async (module) => {
  await import("./styles.css");
  await import("./console-shell.css");
  return module;
}));
const WebsiteRouter = import.meta.env.DEV ? React.lazy(() => import("./website/WebsiteRouter.jsx")) : null;

function Root() {
  return <React.Suspense fallback={null}>{import.meta.env.DEV ? <WebsiteRouter consoleFallback={<App/>}/> : <App/>}</React.Suspense>;
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);
